module.exports = __webpack_public_path__ + "img/instagram_logo.620754d6.png";